var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:['color-plate', _vm.size, { disabled: _vm.disabled, readOnly: _vm.readOnly }],on:{"click":function($event){return _vm.$emit('click')}}},[_c('div',{staticClass:"color-plate__fg",style:(_vm.plateStyle)})])
}
var staticRenderFns = []

export { render, staticRenderFns }